@if (object()) {
<div>
  {{ companyName1 }} {{ companyName2 }}
  @if (taxationID) {
  <span data-testing-id="taxationID">
    <br />{{ 'checkout.widget.buyer.TaxationID' | translate }} {{ taxationID }}
  </span>
  }
  <p>
    {{ userName }}<br />
    {{ object().email || object().invoiceToAddress?.email }}
  </p>
  @if (object().costCenter) {
  <div data-testing-id="buyer-cost-center">
    <strong>{{ 'checkout.widget.buyer.costcenter' | translate }}</strong>
    <p>{{ object().costCenter }} {{ costCenterName }}</p>
  </div>
  } @if (object().externalOrderReference) {
  <div data-testing-id="orderReferenceID">
    @if (editRouterLink()) {
    <a
      class="float-right btn-tool"
      [routerLink]="editRouterLink()"
      [title]="'checkout.update.buyer.title' | translate : { '0': 'checkout.widget.buyer.heading' | translate }"
    >
      <fa-icon [icon]="['fas', 'pencil-alt']" />
    </a>
    }
    <strong>{{ 'checkout.widget.buyer.orderReferenceId' | translate }}</strong>
    <p>{{ object().externalOrderReference }}</p>
  </div>
  }
</div>
}
